import _ from 'lodash';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { pick } from 'lodash/fp';

import { Container } from 'unstated';

import Session from '../models/Session';

export default class PageContainer extends Container {

  subscriptions = []
  
  getPropsFromSession(options) {
    let propsList = this.options.getFromSession;
    if (options && options.getFromSession) {
      propsList = options.propsList;
    }     
    if (propsList && propsList.length) {
      const props = _.pickBy(_.pick(Session.store, propsList), (v) => v);
      this.setState(props);
      return props;
    }
    return _.pick(this.state, propsList);
  }

  setupFlags(flags) {
    this._postUpdateChecks = this._postUpdateChecks || [];

    for (const flag of flags) {
      this._postUpdateChecks.push(() => !this.state[flag.name] && flag.check() && this.setState({ [flag.name]: true }));
    }
  } 

  setState() {
    if (!arguments.length) {
      return;
    }

    return Container.prototype.setState.apply(this, arguments)
      .then(() => (
        this._postUpdateChecks && Promise.all(this._postUpdateChecks.map((fn) => Promise.resolve(fn())))
      ))
      // .then(() => console.log('State updated', this.state));
  }
  
  subscribeToSession() {
    return this.subscribeToStore(Session, this.options.getFromSession);
  }

  subscribeToStore(store, propsList = this.options.propsList) {
    this.subscriptions.push(from(store.changes$).pipe(
      map(pick(propsList))
    ).subscribe(changes => this.setState(state => _.assign(state, changes))));
    return this.setState(store.get(propsList));
  }

  unsubscribeAll() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}

// export default function makePageContainer(defaultState, options) {
//   return class PageContainer extends Container {
//     getPropsFromSession(propsList) {
//       if (propsList && propsList.length) {
//         const props = _.pick(Session, propsList);
//         this.setState(props);
//         Session.on('change', (event) => {
//           // console.log('Got change', event);
//           const changes = _.pick(event, propsList);
//           if (changes) {
//             if (_.keys(changes).length) {
//               this.setState(state => _.chain(state).merge(changes).value())
//                 // .then(() => console.log('Updated state', this.state, this.constructor.name));
//             }
//           }
//         });
//         return props;
//       }
//     }
  
//     setupFlags(flags) {
//       this._postUpdateChecks = this._postUpdateChecks || [];
  
//       for (const flag of flags) {
//         this._postUpdateChecks.push(() => !this.state[flag.name] && flag.check() && this.setState({ [flag.name]: true }));
//       }
//     } 
  
//     setState() {
//       return Container.prototype.setState.apply(this, arguments)
//         .then(() => ( 
//           this._postUpdateChecks && Promise.all(this._postUpdateChecks.map((fn) => Promise.resolve(fn())))
//         ))
//         .then(() => this.updateSession())
//         .then(() => console.log('State updated', this.state));
//     }
  
//     async updateSession() {
//       const updateToSessionValues = this.options.saveToSession.reduce((acc, curr) => {
//         return Object.assign(acc, { [curr]: this.state[curr] });
//       }, {});
  
//       if (Object.keys(updateToSessionValues).length) {
//         return Object.assign(Session, updateToSessionValues);
//       }
//     }
//   }
// }


// WEBPACK FOOTER //
// ./src/containers/PageContainer.js